import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";

export interface UserMenuItemProps {
  title: string;
  icon: () => React.ReactNode;
  url?: string;
  as?: "dropdown" | "sheet";
  onClick?: () => void;
}

export function UserMenuItem({ ...props }: UserMenuItemProps) {
  const { title, icon, url, as = "dropdown", onClick } = props;

  if (as === "sheet") {
    return (
      <a
        onClick={() => {
          if (url) {
            window.location.href = url;
          }
          if (typeof onClick === "function") {
            onClick();
          }
        }}
        className={`flex items-center gap-3 cursor-pointer px-4 py-2`}
      >
        <div className="w-5 h-5">{icon()}</div>

        <span className="text-primary text-sm">{title}</span>
      </a>
    );
  }

  return (
    <DropdownMenuItem
      className="px-2 py-1.5 flex gap-2 cursor-pointer outline-none hover:bg-gray-100"
      onClick={() => {
        if (url) {
          window.location.href = url;
        }
        if (typeof onClick === "function") {
          onClick();
        }
      }}
    >
      <div className="w-5 h-5">{icon()}</div>
      <div className="flex-1 text-xs">{title}</div>
    </DropdownMenuItem>
  );
}
